import React, {  ReactElement } from 'react'
import * as app from "../services/AppService";
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import TooltipElm from 'react-bootstrap/Tooltip';
import { RowItem } from '../models/Core/row-item';
import { InterfaceComponentsProps } from '../models/Core/componentsCore';

export interface ButtonProps extends RowItem, Omit<InterfaceComponentsProps, "LabelClass"> {
    elmKey?: string | number;
    type?: "submit" | "reset" | "button" | undefined;
    clicked: (key: string) => void;
    rounded?: string;
    children?: ReactElement | ReactElement[];
    iconSize?: string;
    formID?: string;
    tooltip?: string;
}

export default function Button(props: ButtonProps) {

    function clicked(e: any) {
        if (props.clicked) props.clicked((props.elmKey||"").toString())
        e.currentTarget.blur(); //الخروج من الزر بعد الضغط عليه
    }

    let btn = (<button type={props.type} className={`btn btn-sm fw-normal focus-ring rounded-${props.rounded} 
         ${props.class} 
         ${(props.icon !== "" && props.rounded !== "circle" ? "  px-2 " : " ")}`}
        onClick={clicked}
        form={props.formID }
        id={props.id ? props.id : "btn" + props.label}
        data-bs-toggle="tooltip" data-bs-placement="top" data-bs-title="Tooltip on top" disabled={props.disabled} >
        <span className={(props.icon !== "" ? "" : " ")}>{app.translate(props.label)}</span>

        {props.children}
        {props.icon && <span className={`fs-${props.iconSize} iconssc-${props.icon + (props.label !== "" ? " ps-3" : " ")}`}> </span>}
    </button>);
    return (app.getBoolean(props.hide) ? <></> :
        !props.tooltip ? btn :
            <OverlayTrigger key={props.elmKey + 'bottom'} placement='bottom'
                overlay={
                    <TooltipElm style={{ position: "fixed" }} id={`tooltip-bottom`}>
                        {app.translate(props.tooltip)}
                    </TooltipElm>
                }>
                {btn}
            </OverlayTrigger>
    );
}

Button.defaultProps = {
    elmKey: "",
    type: "button",
    clicked: () => { },
    rounded: "1",
    icon: "",
    id: "",
    iconSize: "6",
    hide: false,
    tooltip: "",
    disabled: false,
    label: "",
    class: "btn-primary shadow-sm ",
    children: undefined
}

